import { useAuthorization } from '../../../authorization/useAuthorization';
import { ConstantActions } from '../../../Services/_actions/index.js';
import { ACCESS } from '../../../constants/authz/accessPresets.constants';
import { globalpermissions } from '../../../Services/Permission';

/**
 * Profile management CRUD permissions — RBAC v2 object grants with legacy fallback.
 */
export default function useProfileManagementPermissions() {
  const { can, isAuthzV2Enabled } = useAuthorization();
  const constActions = ConstantActions();

  if (isAuthzV2Enabled) {
    return {
      canView: can(ACCESS.PROFILE_MANAGEMENT_VIEW),
      canCreate: can(ACCESS.PROFILE_CREATE),
      canEdit: can(ACCESS.PROFILE_UPDATE),
      canDelete: can(ACCESS.PROFILE_DELETE),
      canManagePermissions: can(ACCESS.PROFILE_UPDATE),
      canClone: can(ACCESS.PROFILE_CREATE),
    };
  }

  const routes = globalpermissions.managementRoutes;
  const hasManage = constActions.userHasPermission([routes.manageProfile]);
  const hasCreate = constActions.userHasPermission([routes.createProfile]);
  const hasEdit = constActions.userHasPermission([routes.editProfile]);

  return {
    canView: hasManage || hasCreate || hasEdit,
    canCreate: hasCreate || hasManage,
    canEdit: hasEdit || hasManage,
    canDelete: hasEdit || hasManage,
    canManagePermissions: hasEdit || hasManage,
    canClone: hasCreate || hasManage,
  };
}
